<template>
  <sidenav :orientation="orientation" :class="curClasses">

    <!-- Inner -->
    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }">

      <sidenav-router-link icon="ion ion-md-business" to="/" :exact="true">Tenants</sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-globe" to="/deployments" :exact="true">Deployments</sidenav-router-link>
      <sidenav-router-link icon="ion ion-ios-code-download" to="/feeds" :exact="true">External Feeds</sidenav-router-link>
<!--      <sidenav-router-link icon="ion ion-ios-cog" to="/services" :exact="true">Services</sidenav-router-link>-->
      <sidenav-menu icon="ion ion-ios-paper" :active="isMenuActive('/audit-trail')" :open="isMenuOpen('/audit-trail')">
        <template slot="link-text">Audit Trail</template>
        <sidenav-router-link to="/audit-trail/tenants" :exact="true">Tenants</sidenav-router-link>
        <sidenav-router-link to="/audit-trail/threatfeeds" :exact="true">Threatfeeds</sidenav-router-link>
      </sidenav-menu>

    </div>
  </sidenav>
</template>

<script>
import { Sidenav, SidenavLink, SidenavRouterLink, SidenavMenu, SidenavHeader, SidenavBlock, SidenavDivider } from '@/vendor/libs/sidenav'

export default {
  name: 'app-layout-sidenav',
  components: {
    /* eslint-disable vue/no-unused-components */
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    SidenavBlock,
    SidenavDivider
    /* eslint-enable vue/no-unused-components */
  },

  props: {
    orientation: {
      type: String,
      default: 'vertical'
    }
  },

  computed: {
    curClasses () {
      let bg = this.layoutSidenavBg

      if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
        bg = bg
          .replace(' sidenav-dark', '')
          .replace(' sidenav-light', '')
          .replace('-darker', '')
          .replace('-dark', '')
      }

      return `bg-${bg} ` + (
        this.orientation !== 'horizontal'
          ? 'layout-sidenav'
          : 'layout-sidenav-horizontal container-p-x flex-grow-0'
      )
    }
  },

  methods: {
    isMenuActive (url) {
      return this.$route.path.indexOf(url) === 0
    },

    isMenuOpen (url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
    },

    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    }
  }
}
</script>
